import { isFoldable } from './is-foldable';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export function initializeSubheading(rootElement: HTMLElement) {
    const subHeadingElement = rootElement.querySelector<HTMLElement>('.js_pdp_short-info__subheading');
    if (!subHeadingElement) return;
    trackView({ product_ShortInfo: isFoldable(subHeadingElement) ? ['foldable'] : ['not_foldable'] });
}
